import React from 'react';
import {
  Alert,
  AlertTitle,
  Button,
  Box,
  CircularProgress,
} from '@mui/material';
import { useSimulation } from '../../Contexts/SimulationContext';
import { useAuth } from '../../Contexts/AuthContext';

const ROLE_NAMES = {
  0: 'Super User',
  1: 'Admin',
  2: 'Contributor',
  3: 'Read-only',
};

const SimulationBanner = () => {
  const auth = useAuth();
  const simulation = useSimulation();

  // Only show for Super Users who are simulating
  if (!auth.activeUser || auth.activeUser.userType !== 0 || !simulation.isSimulating) {
    return null;
  }

  const effectiveRole = simulation.getEffectiveRole();
  const effectiveOrg = simulation.getEffectiveOrganization();

  const getSimulationMessage = () => {
    const parts = [];
    
    if (simulation.simulatedRole !== null) {
      parts.push(`Role: ${ROLE_NAMES[effectiveRole]}`);
    }
    
    if (simulation.simulatedOrganization) {
      parts.push(`Organization: ${effectiveOrg.name}`);
    }
    
    return parts.join(' | ');
  };

  return (
    <Alert 
      severity="warning" 
      sx={{ 
        mb: 2,
        '& .MuiAlert-message': {
          width: '100%',
        }
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <Box>
          <AlertTitle>Simulation Mode Active</AlertTitle>
          {simulation.isRefreshing ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CircularProgress size={16} />
              <span>Refreshing data...</span>
            </Box>
          ) : (
            <span>You are viewing as: {getSimulationMessage()}</span>
          )}
        </Box>
        <Button 
          size="small" 
          variant="outlined" 
          onClick={simulation.clearSimulation}
          disabled={simulation.isRefreshing}
          sx={{ ml: 2 }}
        >
          Exit Simulation
        </Button>
      </Box>
    </Alert>
  );
};

export default SimulationBanner;
